<template>
    <div class="w-full partners__main">
        <div class="mt-8 pt-4 flex flex-row justify-center">
            <span class="font-hairline text-xl pb-2 px-8 font-fira uppercase mt-2 border-v-blue border-b-2">Partnereink</span>
        </div>
    </div>
</template>

<script>
export default {
  data () {
    return {}
  }
}
</script>
<style scoped>
.partners__main {
    height: 308px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partners.vue